import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

// Base
import Modal from '../../../v5/base/modal';

//Related Components
import ForgotPassword from './sign_in_up/forgot_password';
import ResendConfirmation from './sign_in_up/resend_confirmation';
import SignIn from './sign_in_up/sign_in';
import SignUp from './sign_in_up/sign_up';

export default class SignInUp extends React.Component {
  static propTypes = {
    onSignIn: PropTypes.func,
    onSignUp: PropTypes.func,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    opportunity: PropTypes.object,
  }

  static defaultProps = {
    opportunity: {},
  }

  constructor(props) {
    super(props);

    this.state = {
      user: {
        profile_attributes: {},
        opportunity_id: props.opportunity.id,
      },
      v: 'sign_up',
    };
  }

  handleSetView = (v) => {
    this.setState({ v });
  }

  render() {
    const { opportunity, isOpen, onClose, onSignIn, onSignUp } = this.props;
    const { v, user } = this.state;

    return (
      <React.Fragment>
        <Modal {...{
          onClose,
          onCancel: onClose,
          isOpen,
          showX: false,
        }}>
          <div className='absolute top-30 right-30'>
            <X {...{ onClick: onClose }} />
          </div>
          {
            v === 'sign_up' &&
            <SignUp {...{
              user,
              opportunity,
              onSignUp,
              onSetView: this.handleSetView,
            }} />
          }
          {
            v === 'sign_in' &&
            <SignIn {...{
              user,
              opportunity,
              onSignIn,
              onSetView: this.handleSetView,
            }} />
          }
          {
            v === 'forgot_password' &&
            <ForgotPassword {...{
              onSetView: this.handleSetView,
            }} />
          }
          {
            v === 'resend_confirmation' &&
            <ResendConfirmation {...{
              onSetView: this.handleSetView,
            }} />
          }
        </Modal>
      </React.Fragment>
    )
  }
}